import React from "react";
import { toast } from "react-toastify";

import {
  PrimaryButton,
  SecondaryButton,
  Select,
  TextField,
} from "@graffer-inc/console-design-kit";

import { validateCreateServiceAccountKey } from "../../../../../../application/domain/service-account/service-account-validation";

type CreateServiceAccountKeyFormProps = {
  onClickCancel: () => void;
  onClickCreate: (param: {
    expiredAtUnixMilliSecond: number;
    name: string;
  }) => void;
  disabled: boolean;
};

export const CreateServiceAccountKeyForm: React.FC<
  CreateServiceAccountKeyFormProps
> = ({ onClickCancel, onClickCreate, disabled }) => {
  const [expiredAtStr, setExpiredAtStr] = React.useState<"3" | "6" | "12">("3");
  const [name, setName] = React.useState<string>("");

  const [validationState, setValidationState] = React.useState(
    validateCreateServiceAccountKey({ name }),
  );
  const [shouldDisplayError, setShouldDisplayError] =
    React.useState<boolean>(false);

  const handleNameChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setName(e.target.value);
      setValidationState(
        validateCreateServiceAccountKey({ name: e.target.value }),
      );
    },
    [],
  );
  const handleSubmit = React.useCallback(() => {
    setShouldDisplayError(true);
    if (Object.keys(validationState).length > 0) {
      toast.error("入力内容の不備を修正してください。");
      return;
    }
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + Number(expiredAtStr));
    const expiredAtUnixMilliSecond = currentDate.getTime();
    onClickCreate({ expiredAtUnixMilliSecond, name });
  }, [validationState, expiredAtStr, name, onClickCreate]);

  return (
    <div>
      <nav className="level">
        <div className="level-left"></div>
        <div className="level-right">
          <p className="level-item">
            <SecondaryButton
              text="キャンセル"
              onClick={onClickCancel}
              disabled={disabled}
            />
          </p>
          <p className="level-item">
            <PrimaryButton
              text="作成"
              onClick={handleSubmit}
              disabled={disabled}
            />
          </p>
        </div>
      </nav>

      <section>
        <div className="columns">
          <div className="column">
            <Select
              label="有効期限"
              description=""
              required
              value={expiredAtStr}
              options={[
                {
                  name: "3ヶ月",
                  value: "3",
                },
                {
                  name: "6ヶ月",
                  value: "6",
                },
                {
                  name: "1年",
                  value: "12",
                },
              ]}
              onChange={setExpiredAtStr}
            />
          </div>
        </div>

        <div className="columns">
          <div className="column">
            <TextField
              label="キーの名称"
              placeholder="キーの名称を入力してください"
              description={"20文字以内で入力してください。"}
              value={name}
              onChange={handleNameChange}
              errorMessages={validationState.name}
              shouldDisplayError={shouldDisplayError}
            />
          </div>
        </div>
      </section>
    </div>
  );
};
